<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title">{{ $t('UrbanStudies') }}</h1>
          <h2 class="page-subtitle">{{ $t('Total') }} : {{ totalCount }}</h2>
        </div>
        <b-button v-if="allowCreate" variant="primary" @click="clickOnCreateBtn">
          <plus-icon class="mr-1" size="18"/>
          {{ $t('Add') }} {{ $t('a.e') }} {{ $t('urbanStudy.short') }}
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableUrbanStudy"
          :deleteItem=allowDelete
          :editItem=allowEdit
          :empty-button=" $t('Add')+' '+$t('a.e') +' '+ $t('urbanStudy.short')"
          :empty-text="$t('urbanStudy.emptyText').toString()"
          :empty-title="$t('urbanStudy.emptyTitle').toString()"
          :fields="tableFields"
          get-b122-table-results-url="/urbanStudy/getB122TableResults"
          identifier="B122TableUrbanStudy"
          init-b122-table-url="/urbanStudy/initB122Table"
          @add="clickOnCreateBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnShowBtn="clickOnShowBtn"
          @setTotalCount="setTotalCount">

          <template #cell(viability)="data">
            <check-icon v-if="data.item.viability.value === 'VIABLE'" class="text-success" size="26"></check-icon>
            <x-icon v-if="data.item.viability.value === 'NONVIABLE'" class="viability-icon-nonviable"
                    size="24"></x-icon>
            <question-mark-icon v-if="data.item.viability.value === 'TO_DEFINE'" size="24"></question-mark-icon>
          </template>

          <template #cell(actions)="row">
            <div class="actions-container text-right">
              <button class="show-action-btn edit mr-1" @click=clickOnEditBtn(row)>
                <pencil-icon size="18"/>
              </button>
              <button v-if="isEstateAgent || row.item.estateAgent.username === username" class="show-action-btn delete"
                      @click=clickOnDeleteBtn(row)>
                <trash-icon size="18"/>
              </button>
            </div>
          </template>

        </b122-table>
      </b-card>
    </b-container>

    <Item-delete-modal
      :beginsWithVoyel="true"
      :isFeminine="true"
      :selectedItem="ui.selectedUrbanStudy"
      controllerName="urbanStudy"
      itemSingularName="urbanStudy"
      itemSingularNameUpp="UrbanStudy"
      @didDeleteItem="didDeleteUrbanStudy()">
    </Item-delete-modal>

  </div>
</template>

<script>

import B122Table from '../../components/b122/B122Table'
import ItemDeleteModal from '../../components/b122/ItemDeleteModal'
import i18n from "../../i18n"

export default {

  name: 'UrbanStudyIndex',

  components: {
    B122Table,
    ItemDeleteModal
  },

  data() {
    return {
      username: this.$store.getters.username,
      isEstateAgent: this.$store.getters.isEstateAgent,
      totalCount: 0,
      allowCreate: true,
      allowDelete: true,
      allowEdit: true,

      ui: {
        selectedUrbanStudy: null
      }

    }
  },

  computed: {

    tableFields() {
      return [
        {
          label: this.$i18n.t('Show'),
          key: 'show',
          sortable: false
        },
        {
          label: this.$i18n.t('urbanStudy.Name'),
          key: 'name',
          sortable: true
        },
        {
          label: this.$i18n.t('urbanStudy.GeneralInfo'),
          key: 'generalInfo',
          sortable: false,
          formatter: function (value) {
            if (value.length < 50) {
              return value
            } else {
              return value.substring(0, 47) + "..."
            }
          }
        },
        {
          label: this.$i18n.t('creationDate'),
          key: 'creationDate',
          sortable: true,
          formatter: function (value) {
            return new Date(value).toLocaleString('fr-FR')
          }
        },
        {
          label: this.$i18n.t('urbanStudy.isViable'),
          key: 'viability',
          sortable: true
        },
        {
          label: '',
          key: 'actions'
        }
      ]
    }

  },

  methods: {

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'UrbanStudyCreate'
      })
    },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'UrbanStudyShow',
        params: {
          urbanStudyId: row.item.id
        }
      })
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'UrbanStudyEdit',
        params: {
          urbanStudyId: row.item.id
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.ui.selectedUrbanStudy = row.item
      this.$bvModal.show('item-delete-modal')
    },

    didDeleteUrbanStudy() {
      this.ui.selectedUrbanStudy = null
      this.$refs.B122TableUrbanStudy.refreshTable()
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/urbanStudy/UrbanStudyIndex.vue